import { Link } from "react-router-dom";
import { categories, siteInfo } from "@/mocks/videoData";

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 py-12">
          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">
              <Link to="/category/remen-tuijian">热门分类</Link>
            </h4>
            <ul className="flex flex-col gap-2">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.slug}>
                  <Link to={`/category/${cat.slug}`} className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap" rel="nofollow">
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">
              <Link to="/category/zuixin-shangxian">精彩推荐</Link>
            </h4>
            <ul className="flex flex-col gap-2">
              <li><Link to="/category/dianying" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap" rel="nofollow">热门电影</Link></li>
              <li><Link to="/category/dianshiju" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap" rel="nofollow">热播剧集</Link></li>
              <li><Link to="/category/zongyi" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap" rel="nofollow">综艺精选</Link></li>
              <li><Link to="/category/dongman" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap" rel="nofollow">动漫专区</Link></li>
              <li><Link to="/category/duanju" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap" rel="nofollow">精彩短剧</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">
              平台导航
            </h4>
            <ul className="flex flex-col gap-2">
              <li><span className="text-sm text-foreground-600 whitespace-nowrap">久久视频</span></li>
              <li><span className="text-sm text-foreground-600 whitespace-nowrap">芒果视频</span></li>
              <li><span className="text-sm text-foreground-600 whitespace-nowrap">97视频</span></li>
              <li><span className="text-sm text-foreground-600 whitespace-nowrap">丝瓜视频</span></li>
              <li><span className="text-sm text-foreground-600 whitespace-nowrap">蓝莓视频</span></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">
              <Link to="/about">关于我们</Link>
            </h4>
            <ul className="flex flex-col gap-2">
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap" rel="nofollow">
                  品牌介绍
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap" rel="nofollow">
                  联系我们
                </Link>
              </li>
              <li className="text-sm text-foreground-500 mt-2 flex items-center gap-1">
                <i className="ri-mail-line text-xs"></i>
                <span>{siteInfo.email}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="py-6 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-foreground-500">
          <p>&copy; {new Date().getFullYear()} {siteInfo.name} - 版权所有</p>
          <div className="flex items-center gap-4">
            <span>久久视频 | 芒果视频 | 97视频 | 丝瓜视频</span>
          </div>
        </div>
      </div>
    </footer>
  );
}